export const dateRange = [
  {
    label: 'Last 7 days',
    value: 7,
  },
  {
    label: 'Last 14 days',
    value: 14,
  },
  {
    label: 'Last 30 days',
    value: 30,
  },
  {
    label: 'Last 60 days',
    value: 60,
  },
  {
    label: 'Last 90 days',
    value: 90,
  },
];

export const appMetadata = 'https://krwr.net/app_metadata';

export { MdmIntegrationId as MDM_INTEGRATION_SETTINGS_ID } from '@kw/constants';

export const ACCESS_TOKEN = 'accessToken';
export const ACTIVE_SUB_KEY = 'ACTIVE_SUB_KEY';
export const LAST_BROADCAST_KEY = 'LAST_BROADCAST_KEY';
export const STALE_KEY = 'STALE_KEY';
export const LOGOUT_KEY = 'LOGOUT_KEY';
